import { render, staticRenderFns } from "./ItemizeHomestay.vue?vue&type=template&id=3845d562"
import script from "./ItemizeHomestay.vue?vue&type=script&lang=js"
export * from "./ItemizeHomestay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports